export class InvoiceComplaint {
    constructor(id : string, comment : string){
        this.InvoiceId = id;
        this.Comment = comment;
    }

    public InvoiceId: string | null;
    public Comment: string | null;
    }
